/**
 * 认证布局：居中卡片布局（登录/注册共用）。
 *
 * @module layouts/AuthLayout
 */
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

/** AuthLayout 属性。 */
export interface AuthLayoutProps {
  /** 标题。 */
  title: string;
  /** 副标题。 */
  subtitle?: string;
  /** 表单内容。 */
  children: ReactNode;
  /** 底部补充区（如跳转链接）。 */
  footer?: ReactNode;
}

/**
 * 认证页布局（居中卡片）。
 *
 * @param props 组件属性。
 * @returns JSX 元素。
 */
export default function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: AuthLayoutProps): JSX.Element {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.50',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          borderRadius: 4,
          p: { xs: 3, sm: 5 },
          width: '100%',
          maxWidth: 420,
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography variant="h5" fontWeight={800} color="primary">
            寇豆码 AI Token 中转站
          </Typography>
          <Typography variant="h6" sx={{ mt: 1 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {children}
        {footer && (
          <Box sx={{ mt: 3, textAlign: 'center' }}>{footer}</Box>
        )}
      </Paper>
    </Box>
  );
}
